import { createSlice } from '@reduxjs/toolkit';
import { fetchWrapper } from '../../_helpers/fetchWrapper';

export const initialState = {
  loading: false,
  notificationCount: 0,
  notifications: [],
  notificationAlert: null
};

// A slice
const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    incrementNotificationCount: (state, action) => {
      state.notificationCount = action.payload.unread_count;
    },
    clearNotificationCount: (state) => {
      state.notificationCount = 0;
    },
    setNotifications: (state, action) => {
      state.notifications = action.payload.notification;
    },
    setNotificationAlert: (state, action) => {
      state.notificationAlert = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

// Actions generated from the slice
const {
  incrementNotificationCount,
  clearNotificationCount,
  setNotifications,
  setNotificationAlert,
  setLoading
} = notificationSlice.actions;

// export The reducer
const notificationReducer = notificationSlice.reducer;

export default notificationReducer;

// Actions
export const fetchNotification = () => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await fetchWrapper.get('/notification/');
    dispatch(setNotifications({ notification: response.data.results }));
    dispatch(setLoading(false));
    dispatch(clearNotificationCount());
  } catch (error) {
    // dispatch(getUsersFailure());
    dispatch(setLoading(false));
  }
};

export const handleNotificationCount = (eventData) => async (dispatch) => {
  try {
    dispatch(incrementNotificationCount(eventData));
  } catch (error) {
    console.log(error);
  }
};

export const handleNotificationAlert = (eventData) => async (dispatch) => {
  try {
    dispatch(setNotificationAlert(eventData));
  } catch (error) {
    console.log(error);
  }
};
